import { useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/AuthContext';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import { useControlNavBarContext } from '../../hooks/ControlNavBar';
import Wrapper from '../../components/Wrapper/Wrapper';
import './UserProfile.scss';

const SILVIO_HEADER = `${process.env.PUBLIC_URL}/silvio-header.svg`;

const TABS = [
  { id: 'sobre', label: 'Sobre', path: '/perfil/sobre' },
  // { id: 'conquistas', label: 'Conquistas', path: '/perfil/conquistas' },
  // { id: 'carteira', label: 'Carteira', path: '/perfil/carteira' },
  // { id: 'interesses', label: 'Interesses', path: '/perfil/interesses' },
  { id: 'atividades', label: 'Atividades', path: '/perfil/atividades' },
  { id: 'seguranca', label: 'Segurança', path: '/perfil/seguranca' },
  { id: 'preferencias', label: 'Preferências', path: '/perfil/preferencias' }
];

export default function UserProfile() {
  const location = useLocation();
  const { user } = useAuthContext();
  const { setLoadingFullScreen } = useControllerFlowStepsContext();
  const { setShowButton } = useControlNavBarContext();

  useEffect(() => {
    setLoadingFullScreen(false);
    setShowButton(false);
  }, []);

  const userName =
    (user?.hasSocialName && user?.socialName) || user?.userName || 'Usuário';
  const userInitial = userName.charAt(0).toUpperCase();

  const activeTabId = TABS.find((t) =>
    location.pathname.startsWith(t.path)
  )?.id;

  return (
    <Wrapper>
      <div className="user-profile">
        <div className="user-profile__header-card">
          <div className="user-profile__banner">
            <img
              alt=""
              className="user-profile__banner-silvio"
              src={SILVIO_HEADER}
            />
          </div>

          <div className="user-profile__identity">
            <div className="user-profile__avatar-wrap">
              <div className="user-profile__avatar">{userInitial}</div>
              <div className="user-profile__avatar-badge" />
            </div>
            <p className="user-profile__username">{userName}</p>
          </div>

          <div className="user-profile__tabs">
            {TABS.map((tab) => {
              const isActive = activeTabId === tab.id;
              return (
                <Link
                  key={tab.id}
                  to={tab.path}
                  className={`user-profile__tab${isActive ? ' user-profile__tab--active' : ''}`}
                >
                  {tab.label}
                  {isActive && <span className="user-profile__tab-indicator" />}
                </Link>
              );
            })}
          </div>
        </div>

        <Outlet />
      </div>
    </Wrapper>
  );
}
